import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortCaret = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(3 0) scale(3)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2.62441 7.39843C2.45991 7.39843 2.30801 7.32283 2.21141 7.20383L0.153413 5.14233C0.104626 5.09357 0.0659249 5.03568 0.03952 4.97197C0.0131151 4.90825 -0.000475183 4.83995 -0.000475177 4.77098C-0.000475171 4.70201 0.0131152 4.63371 0.03952 4.56999C0.0659249 4.50627 0.104626 4.44838 0.153413 4.39963C0.202036 4.35099 0.259764 4.31241 0.323301 4.28608C0.386838 4.25976 0.454938 4.24621 0.523712 4.24621C0.592487 4.24621 0.660587 4.25976 0.724124 4.28608C0.787661 4.31241 0.845389 4.35099 0.894012 4.39963L2.09941 5.60223L2.09941 1.52341C2.09941 1.38417 2.15473 1.25064 2.25318 1.15218C2.35164 1.05372 2.48517 0.998413 2.62441 0.998413C2.76365 0.998413 2.89719 1.05373 2.99564 1.15218C3.0941 1.25064 3.14941 1.38417 3.14941 1.52341L3.14941 5.60923L4.35481 4.39613C4.40345 4.34739 4.46122 4.30871 4.52482 4.28233C4.58842 4.25594 4.65661 4.24236 4.72546 4.24236C4.79432 4.24236 4.8625 4.25594 4.9261 4.28233C4.9897 4.30871 5.04748 4.34739 5.09611 4.39613C5.1449 4.44488 5.1836 4.50277 5.21001 4.56649C5.23641 4.63021 5.25 4.69851 5.25 4.76748C5.25 4.83645 5.23641 4.90475 5.21 4.96847C5.1836 5.03218 5.1449 5.09007 5.09611 5.13883L2.99331 7.24443C2.9453 7.29354 2.8879 7.33249 2.82452 7.35894C2.76115 7.3854 2.69309 7.39883 2.62441 7.39843Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgSortCaret);
export default ForwardRef;
